import { ChangeDetectorRef, inject, OnDestroy, Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { DomainDataService } from "../../services/domain-data.service";

@Pipe({ name: "translateModel", pure: false })
export class TranslateModelPipe implements PipeTransform, OnDestroy {
    onLangChange: Subscription | undefined;

    private readonly cdr = inject(ChangeDetectorRef);
    private readonly domainDataService = inject(DomainDataService);
    private readonly translateService = inject(TranslateService);

    lastKey: string | null = null;
    value = "";

    updateValue(value: string) {
        const result = this.domainDataService.translate(value);

        if (result) {
            this.value = result;
            this.lastKey = value;
            this.cdr.markForCheck();
        }
    }

    transform(value: string): string {
        if (value === this.lastKey) {
            return this.value;
        }

        this.lastKey = value;
        this.updateValue(value);
        this.dispose();

        if (!this.onLangChange) {
            this.onLangChange = this.translateService.onLangChange.subscribe(() => {
                if (this.lastKey) {
                    this.lastKey = null;
                    this.updateValue(value);
                }
            });
        }

        return this.value;
    }

    private dispose() {
        if (this.onLangChange) {
            this.onLangChange.unsubscribe();
            this.onLangChange = undefined;
        }
    }

    ngOnDestroy() {
        this.dispose();
    }
}
